const DEBUG_PHEAD ={"signatureD":"1iyHk+Ccscjw26PZc9aqieZbUYheg5EaZUNZgcFA2hg=","signatureWebD":"plEqxCi3Z+exhHxo2mtSE8F8Af\/dLWVwAMmiHOhkkOU=","signatureI":"","platform":"android","prdId":"18106","activityChannel":"281000","currentChannel":"281000","version":"2.28.1.8.7","versionCode":22818,"appVersion":"1.0","appVersionCode":999,"pversion":0,"qaid":"5ba85956d25a6f6a107c4734422721d59dc2df016c125b75c64fc853978f3cde","startFrom":"","phone":"vivo","manufacturer":"vivo","model":"V2118A","sysVersion":"12","pkgName":"com.starbaba.bubuduojin","digitalUnionId":"DU3LFpnVlyzOo0XZbGKaBD5YMgRtlEOkx2f0","userId":"1410931485061545986","shumeiDeviceId":"BNsqyHFRTCwvlTEAdgx5XI0wE\/XS3NbD3XIUpmLBdDwitn07kfzSigjo2yE3gITN\/vRfdrqCVfL7TK2YGQkFDqQ==","timestamp":1672798938887,"signature":"f01b62523cc4f6b9776aa0d4f0c7a1df"}
const DEBUG_ADHEAD ={"signatureD":"1iyHk+Ccscjw26PZc9aqieZbUYheg5EaZUNZgcFA2hg=","signatureWebD":"plEqxCi3Z+exhHxo2mtSE8F8Af\/dLWVwAMmiHOhkkOU=","signatureI":"","platform":"android","prdId":"18106","activityChannel":"281000","currentChannel":"281000","version":"2.28.1.8.7","versionCode":22818,"appVersion":"1.0","appVersionCode":999,"pversion":0,"qaid":"5ba85956d25a6f6a107c4734422721d59dc2df016c125b75c64fc853978f3cde","startFrom":"","phone":"vivo","manufacturer":"vivo","model":"V2118A","sysVersion":"12","pkgName":"com.starbaba.bubuduojin","digitalUnionId":"DU3LFpnVlyzOo0XZbGKaBD5YMgRtlEOkx2f0","userId":"1410931485061545986","shumeiDeviceId":"BNsqyHFRTCwvlTEAdgx5XI0wE\/XS3NbD3XIUpmLBdDwitn07kfzSigjo2yE3gITN\/vRfdrqCVfL7TK2YGQkFDqQ==","timestamp":1672798938887,"signature":"f01b62523cc4f6b9776aa0d4f0c7a1df"}
// let HOST_SET = {
//     dev: "http://dev.vipgift.gmilesquan.com",
//     test: "http://test.ibestfanli.com",
//     prerelease: "http://pregame.quzhuanxiang.com",
//     release: "http://commerce.ibestfanli.com",
// }
// let env = process.env.SERV_ENV || 'test'; // 服务器环境
// let host = process.env.SERV_HOST || HOST_SET[env];
export default {
    host: process.env.SERV_HOST || "http://test.ibestfanli.com",
    getDebugPhead() {
      return DEBUG_PHEAD;
    },
    getDebugAdHead() {
      return DEBUG_ADHEAD;
    },
    getNativePhead() {
      let phead;
      if (typeof window !== 'undefined' && window.dsBridge) {
        const pheadString = dsBridge.call('getPheadString');
        if (pheadString) {
          phead = JSON.parse(pheadString);
        }
      }
      return phead || DEBUG_PHEAD;
    },  
    getNativeAdhead() {
      let adhead;
      if (typeof window !== 'undefined' && window.dsBridge) {
        const adheadString = dsBridge.call('getAdheadString');
        if (adheadString) {
          adhead = JSON.parse(adheadString);
        }
      }
      return adhead || DEBUG_ADHEAD;
    }
}